import { render, staticRenderFns } from "./SentimentTable.vue?vue&type=template&id=2ff95ce2&"
import script from "./SentimentTable.vue?vue&type=script&lang=js&"
export * from "./SentimentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports